import React from "react";
import styles from "../styles/privacypolicyscreen.module.css";
import SideBar from "../store/containers/SideBarContainer";

const PrivacyPolicyScreen = (props) => {
  return (
    <div className={styles.container}>
      <SideBar />
      <h1>Workers App Privacy Policy</h1>
      <p>
        This privacy policy governs your use of a software application
        ("Application”) on a mobile device that was created by Palo Alto Data
        Group. The application includes information on worker rights under
        California state and federal laws, along with links to the applicable
        state and federal agencies. While this information is designed to help
        workers understand their legal rights, it is not intended as legal
        advice. For legal advice you should contact an attorney, or the
        appropriate agency identified in the Application.
      </p>
      <p>
        The Application does not require any user registration and does not
        collect or store any personal data from users. No user information or
        location data is collected, automatically or otherwise. We do not use
        the Application to solicit data from or market to children under the age
        of 13.
      </p>
      <p>
        This Privacy Policy may be updated from time to time for any reason. We
        will notify you of any changes to our Privacy Policy by posting the new
        Privacy Policy{" "}
        <a href="https://workers-rights-portal.herokuapp.com/privacy-policy">
          here
        </a>
        . You are advised to consult this Privacy Policy regularly for any
        changes.
      </p>
      <p>
        If you have any questions regarding privacy while using the Application,
        or have questions about our practices, please contact us via email to
        rsilvertaube@scu.edu.
      </p>
    </div>
  );
};

export default PrivacyPolicyScreen;
